import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'

import { GridItem } from 'Components/Page/StatsPageWrapper'
import TimeLine from 'Components/TimeLine'
import { authorization } from 'Module/Auth/Auth'
import { steps } from './options'
import {
  updateCampaignDeliverabilityStatusGQL,
  getCampaignsDeliverabilityStatus,
} from './gql'
import { styles } from './styles'
import useGraphQLFetch from '../../../../Utils/Hooks/useGraphQLFetch'
import LoadingIndicator from '../../../../Components/LoadingIndicator/LoadingIndicator'

const CampaignTimeline = ({ classes, campaignId }) => {
  const { data: deliverabilityReport, isLoaded } = useGraphQLFetch({
    fetchFn: getCampaignsDeliverabilityStatus,
    defaultFetchArgs: campaignId,
    mapResponse: data => data.campaign.deliverabilityReport,
  })

  const [isEditMode, setEditMode] = useState(false)
  const [step, setStep] = useState(null)
  const indexChangedStep = steps.findIndex(item => item.value === step)

  useEffect(() => {
    if (isLoaded && !isEditMode) {
      setStep(deliverabilityReport.status)
    }
  }, [isEditMode, isLoaded])

  const handleEdit = (_, index) => {
    if (isEditMode) {
      setStep(steps[index].value)
    }
  }

  const handleSave = async () => {
    try {
      if (
        steps.findIndex(item => item.value === deliverabilityReport.status) !==
        indexChangedStep
      ) {
        await updateCampaignDeliverabilityStatusGQL({
          id: deliverabilityReport.id,
          status: step,
        })
      }
    } finally {
      setEditMode(false)
      setStep(step)
    }
  }
  return (
    <div>
      <div className={classes.header}>
        <div className={classes.title}>Timeline</div>
        {authorization.isAdmin() && isLoaded && (
          <div className={classes.wrapperButtons}>
            <div onClick={handleSave} className={classes.button}>
              {isEditMode ? 'Save' : ''}
            </div>
            <div
              onClick={() => setEditMode(!isEditMode)}
              className={classes.button}
            >
              {isEditMode ? 'Cancel' : 'Edit'}
            </div>
          </div>
        )}
      </div>
      {isLoaded ? (
        <GridItem>
          <TimeLine
            isEditMode={isEditMode}
            items={steps}
            activeIndex={indexChangedStep}
            onEdit={handleEdit}
          />
        </GridItem>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  )
}

export default injectStyles(styles)(CampaignTimeline)



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignTimeline/index.js